/* eslint-disable indent */
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { newLayout } from '../../../../theme';

export const StyledTypography = styled(Typography)`
  && {
    font-size: ${newLayout.fontSize.body1};
  }
`;
